import ProjectService from "src/services/ProjectService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	REMOVE_PLAN: "project/remove_plan",
	CHECK_SUBSCRIPTION: "project/check_subscription",
};
export const params = {
	subject: "",
	domain: "",
	redirect: "",
	show_redirect: "1",
	description: "",
	closed_at: "",
};

/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.project,
 @property  {array}  modules.projects
 **/

const module = {
	state: {},
	mutations: {
		[types.REMOVE_PLAN] (state, plan) {
			const removeIndex = state.project.plans.map(item => item.id).indexOf(plan.id);
			state.plans = state.project.plans.splice(removeIndex, 1);
		},
	},
	getters: {},
	actions: {
		[types.CHECK_SUBSCRIPTION] (context, payload) {
			return ProjectService.checkSubscription(payload.userId, payload.projectHash).then((response) => {
				return response;
			});
		},
	},
	types: types,
};
export default ModuleCreator("project", ProjectService, module, types, params);
